module.exports = __webpack_public_path__ + "static/media/pk.0ddc1b8d.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/pk.svg
// module id = 2188
// module chunks = 0